import config from "./firebase.config";

const firebaseApi = {
  getLocation: (companyId, location, callback) => {
    config.firestore.collection("companies").doc(companyId).collection("locations").doc(location).get().then(callback);
  },

  updateLocation: (companyId, location, data, callback) => {
    if (data.workHours) {
      data.workHours = { ...data.workHours };
      for (let i = 0; i <= 6; i++) {
        if (!data.workHours[i]) {
          data.workHours[i] = config.firebase.firestore.FieldValue.delete();
        }
      }
    }
    config.firestore.collection("companies").doc(companyId).collection("locations").doc(location).set(data, { merge: true }).then(callback);
  },

  updateCompanySchedule: (companyId, scheduleId, data, callback) => {
    config.firestore.collection("companies").doc(companyId).collection("schedules").doc(scheduleId).set(data, { merge: true }).then(callback);
  },

  deleteCompanySchedule: async (companyId, scheduleId, currentUserId, source, lockDocId, callback) => {
    let scheduleSnap = await config.firestore.collection("companies").doc(companyId).collection("schedules").doc(scheduleId).get();

    if (scheduleSnap) {
      let scheduleDoc = scheduleSnap.data();
      scheduleDoc.cancelledData = {
        cancelledByUser: currentUserId && source ? false : true,
        cancelledDateTime: Math.floor(Date.now() / 1000),
        cancelledById: {},
      };
      if (currentUserId && source) scheduleDoc.cancelledData.cancelledById[source] = currentUserId;

      await config.firestore.collection("companies").doc(companyId).collection("cancelledSchedules").doc(scheduleId).set(scheduleDoc);

      //also delete the lock doc as it can be rescheduled again.
      config.firestore.collection("companies").doc(companyId).collection("locks").doc(lockDocId).delete();
      config.firestore.collection("companies").doc(companyId).collection("schedules").doc(scheduleId).delete().then(callback);
    }
  },

  getCompanySchedule: (companyId, scheduleId, callback) => {
    config.firestore.collection("companies").doc(companyId).collection("schedules").doc(scheduleId).get().then(callback);
  },

  getPendingLocationSchedules: (companyId, locationId, callback) => {
    config.firestore
      .collection("companies")
      .doc(companyId)
      .collection("schedules")
      .where("locationId", "==", locationId)
      .where("schedule.startTime", ">=", Math.floor(new Date().getTime() / 1000))
      .get()
      .then(callback);
  },

  getAgents: (source, companyId, locationId, callback) => {
    if (source === "inside") {
      config.firestore.collection("companies").doc(companyId).collection("agents").where("locations", "array-contains", locationId).get().then(callback);
    } else {
      config.firestore.collection("companies").doc(companyId).collection("agents").where("locationId", "==", locationId).get().then(callback);
    }
  },

  getAgent: (companyId, agentId, callback) => {
    config.firestore.collection("companies").doc(companyId).collection("agents").doc(agentId).get().then(callback);
  },

  updateAgent: (companyId, agentId, data, callback) => {
    if (data.workHours) {
      data.workHours = { ...data.workHours };
      for (let i = 0; i <= 6; i++) {
        if (!data.workHours[i]) {
          data.workHours[i] = config.firebase.firestore.FieldValue.delete();
        }
      }
    }
    config.firestore.collection("companies").doc(companyId).collection("agents").doc(agentId).set(data, { merge: true }).then(callback);
  },

  getAgentSchedule: (companyId, scheduleId, callback) => {
    config.firestore.collection("companies").doc(companyId).collection("schedules").doc(scheduleId).get().then(callback);
  },

  getPendingAgentSchedules: (companyId, agentId, callback) => {
    config.firestore
      .collection("companies")
      .doc(companyId)
      .collection("schedules")
      .where("agentId", "==", agentId)
      .where("schedule.startTime", ">=", Math.floor(new Date().getTime() / 1000))
      .get()
      .then(callback);
  },

  createSchedule: async (companyId, data, callback) => {
    // when creating schedule, run the transaction and see if the timeslot is already taken, if so then show the error.
    const lockDocId = data.agentId + "_" + data.schedule.startTime;
    const apptCollectionRef = config.firestore.collection("companies").doc(companyId).collection("schedules");
    const lockRef = config.firestore.collection("companies").doc(companyId).collection("locks").doc(lockDocId);

    const res = await config.firestore.runTransaction(async (t) => {
      const lockDoc = await t.get(lockRef);
      if (lockDoc.exists && lockDoc.data().locked) {
        return { success: false, error: "Time slot is already booked.. Please try another slot." };
      }

      t.set(lockRef, {
        locked: true,
        lockedBy: data.user.id || data.user.name,
        timestamp: Math.floor(Date.now() / 1000),
      });

      const newDoc = apptCollectionRef.doc();
      t.set(newDoc, data);
      return { success: true, error: "", docData: { id: newDoc.id } };
    });

    callback(res);
  },

  getCompany: async (source, companyId, company) => {
    let companyDoc = await config.firestore.collection("companies").where(`ids.${source}`, "==", companyId).get();

    if (companyDoc.empty) {
      return null;
    } else {
      if (company) {
        config.firestore
          .collection("companies")
          .doc(companyDoc.docs[0].id)
          .set(company, { merge: true })
          .then(() => {});
      }
      if (companyDoc.docs.length > 1) {
        let min = {};
        companyDoc.forEach((x) => {
          let data = { ...x.data(), id: x.id };
          if (!data.createdDate) return;
          if (!min.createdDate || data.createdDate < min.createdDate) {
            min = { id: data.id, createdDate: data.createdDate };
          }
        });
        return { id: min.id };
      } else {
        return companyDoc.docs[0];
      }
    }
  },

  getOrCreateLocation: async (companyId, source, locationId, location) => {
    let locationDoc = await config.firestore.collection("companies").doc(companyId).collection("locations").where(`ids.${source}`, "==", locationId).get();

    if (locationDoc.empty) {
      let ids = {};
      ids[source] = locationId;
      let data = location ? { ...location, ids: ids } : { ids: ids };
      locationDoc = config.firestore.collection("companies").doc(companyId).collection("locations").add(data);

      return locationDoc;
    } else {
      if (location) {
        config.firestore
          .collection("companies")
          .doc(companyId)
          .collection("locations")
          .doc(locationDoc.docs[0].id)
          .set(location, { merge: true })
          .then(() => {});
      }
      return locationDoc.docs[0];
    }
  },

  getLocationAsync: async (companyId, locationId) => {
    let locDoc = await config.firestore.collection("companies").doc(companyId).collection("locations").doc(locationId).get();
    if (locDoc.exists) {
      return { ...locDoc.data(), id: locDoc.id };
    }

    return null;
  },

  getOrCreateAgent: async (companyId, source, agentId, agent) => {
    let agentDoc = await config.firestore.collection("companies").doc(companyId).collection("agents").where(`ids.${source}`, "==", agentId).get();

    if (agentDoc.empty) {
      let ids = {};
      ids[source] = agentId;
      let data = agent ? { ...agent, ids: ids } : { ids: ids };
      agentDoc = config.firestore.collection("companies").doc(companyId).collection("agents").add(data);

      return agentDoc;
    } else {
      if (agent) {
        config.firestore
          .collection("companies")
          .doc(companyId)
          .collection("agents")
          .doc(agentDoc.docs[0].id)
          .set(agent, { merge: true })
          .then(() => {});
      }
      return agentDoc.docs[0];
    }
  },

  getOrCreateBrand: async (companyId, source, id) => {
    let brandDoc = await config.firestore.collection("companies").doc(companyId).collection("brands").where(`ids.${source}`, "==", id).get();

    if (brandDoc.empty) {
      let ids = {};
      ids[source] = id;
      brandDoc = config.firestore.collection("companies").doc(companyId).collection("brands").add({ ids: ids });

      return brandDoc;
    }

    return brandDoc.docs[0];
  },

  sendEmail: (body, callback, retries = 1) => {
    fetch(config.mailUrl, {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (callback) {
          callback(data);
        }
      })
      .catch((err) => {
        if (retries > 0) {
          console.log(`Retrying attempt = ${retries}`);
          firebaseApi.sendEmail(body, callback, retries - 1);
        }
        console.log(err);
      });
  },

  sendCancelEmail: (body, callback) => {
    fetch(`${config.mailUrl}/cancel`, {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (callback) {
          callback(data);
        }
      })
      .catch((err) => console.log(err));
  },

  getAgentById: (agentId, callback) => {
    fetch(`${config.ctsUrl}getAgentById?agent=${agentId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (callback) {
          callback(data);
        }
      })
      .catch((err) => console.log(err));
  },

  updateAgentScheduling: (agentId, isSchedulingEnabled, callback) => {
    fetch(`${config.ctsUrl}updateAgentScheduling?agent=${agentId}`, {
      method: "POST",
      body: JSON.stringify({
        uid: agentId,
        isSchedulingEnabled: isSchedulingEnabled,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((data) => {
        if (callback) {
          callback();
        }
      })
      .catch((err) => console.log(err));
  },
};

export default firebaseApi;
